import { render, staticRenderFns } from "./dr-file-viewer.vue?vue&type=template&id=3de477ba"
import script from "./dr-file-viewer.vue?vue&type=script&lang=js"
export * from "./dr-file-viewer.vue?vue&type=script&lang=js"
import style0 from "./dr-file-viewer.vue?vue&type=style&index=0&id=3de477ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports